<template>
  <div class="domain__menu" ref="lnb">
    <ui-logo :target="'domain'" :is-logo-white="false"/>
    <p v-if="isEditMode" class="edit-mode-title" :class="{ab: isABPlan}">{{ $t('common.editMode') }}</p>
    <span class="domain__menu-shadow" :class="{ scrolled: !isContentHeaderScrollTop }"></span>
    <div class="domain__list--group">
      <div class="domain__list--title">
        <span class="icon-wrap">
          <i class="icon icon--analysis-reports" />
        </span>
        <p>Analysis Reports</p>
      </div>
      <ul class="domain__list--wrap"
          ref="domainList"
          :class="{ 'scrolled': !isContentHeaderScrollTop, 'edit-mode': isEditMode, ab: isABPlan }"
          @scroll="onDomainListScroll">
        <li v-for="(item, index) in domains"
            :key="index"
            :class="{ fold: item.isExpanded, hide: item.sid !== currentSid && isEditMode }"
            class="domain-item">
          <p @click="onDomainClick(item)"
             class="domain-text"
             :title="item.domain"
             :class="{ on: item.sid === currentSid, 'edit-mode': isEditMode }">
            {{ item.domain }}
            <i class="icon icon--toggle-slide14"></i>
          </p>
          <ul class="site__list--wrap" v-if="item.sid === currentSid">
            <li v-for="(siteCode, index) in item.site_code" :key="'code' + index"
              class="site-item ellipsis"
              :class="{ fold: siteCode === currentSiteCode && isCurrentSiteCodeFold, on: siteCode === currentSiteCode }">
              <p @click="onSiteCodeClick(siteCode)"
                 class="site-text"
                 :title="siteCode"
                 :class="{ on: siteCode === currentSiteCode, 'edit-mode': isEditMode }">
                {{ siteCode }}
                <i class="icon icon--toggle-slide14"></i>
              </p>
              <ul class="category__list--wrap" v-if="siteCode === currentSiteCode">
                <li v-for="(category, index) in domainCategories" :key="index"
                  class="category-item ellipsis"
                  :class="{
                    'edit-mode': isEditMode,
                    active: currentDashboardCategory.index === index &&
                    currentDashboardCategory.categoryId === category._id
                  }"
                  @click="onUpdateCurrentCategoryIndex(index, category._id)">
                  <template v-if="category._id === '__shared__'">{{ $t('dashboard.pageShare.folderTitle') }}</template>
                  <template v-else>{{ category._id }}</template>
                  <i v-if="hasSharedApply(category) || category._id === '__shared__'" class="icon icon--shared"></i>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { EventBus } from '@/libs/event-bus'
import UiLogo from '@/components/ui/UiLogo.vue'

export default {
  name: 'DomainList',
  data () {
    return {
      selectedItem: {},
      isCurrentSiteCodeFold: true,
      isContentHeaderScrollTop: true
    }
  },
  components: {
    UiLogo
  },
  props: [
    'isEditMode',
    'domains',
    'currentSid',
    'currentSiteCode',
    'domainCategories'
  ],
  computed: {
    ...mapState([
      'currentDashboardCategory',
      'isABPlan',
      'applyData'
    ])
  },
  mounted () {
    EventBus.$on('scrollUpdateCurrentCategoryIndex', (index, categoryId) => {
      this.setCurrentDashboardCategory({
        categoryId,
        index
      })
    })
  },
  methods: {
    ...mapMutations([
      'setCurrentDashboardCategory'
    ]),
    hasSharedApply (category) {
      let hasSharedApply = false
      for (const apply of category.applies) {
        if (apply.shared) hasSharedApply = true
      }
      return hasSharedApply
    },
    onDomainClick (item) {
      this.isCurrentSiteCodeFold = true
      this.$emit('onDomainSelect', item)
    },
    onSiteCodeClick (item) {
      if (this.currentSiteCode === item) {
        this.isCurrentSiteCodeFold = !this.isCurrentSiteCodeFold
      } else {
        this.isCurrentSiteCodeFold = true
      }
      this.onUpdateCurrentCategoryIndex(0, item)
      this.$emit('onSiteCodeSelect', item)
    },
    onDomainListScroll (event) {
      this.isContentHeaderScrollTop = event.currentTarget.scrollTop === 0
    },
    onUpdateCurrentCategoryIndex (index, categoryId) {
      this.setCurrentDashboardCategory({
        categoryId,
        index
      })
      EventBus.$emit('updateCurrentCategoryIndex', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.domain__menu {
  font-family: "Pretendard Variable", "Pretendard JP Variable", sans-serif;
  .edit-mode-title {
    font-size: 22px;
    font-weight: bold;
    line-height: 1;
    color: #289eef;
    position: absolute;
    top: 88px;
    left: 12px;

    &.ab {
      top: 137px;
    }
  }

  .domain__menu-shadow.scrolled {
    content: '';
    display: block;
    width: 210px;
    height: 12px;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.18), rgba(0, 0, 0, 0));
    position: relative;
    top: 46px;
    left: 0;
    z-index: 2;
    pointer-events: none;
  }

  .domain__list--group {
    top: 201px;
    border-top: 1px solid #AAA;
    border-bottom: 1px solid #AAA;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 210px;

    .domain__list--title {
      padding: 12px 10px 14px 10px;
      display: flex;
      align-items: center;
      gap: 4px;
      width: 210px;
      box-sizing: border-box;

      .icon-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
      }

      p {
        color: #222;
        font-size: 14px;
        font-weight: 600;
        line-height: 100%; /* 14px */
      }
    }
    .domain__list--wrap {
      box-sizing: border-box;
      min-height: 100%;
      max-height: calc(100vh - 244px);
      overflow-y: auto;
      width: 176px;

      &.edit-mode {
        top: 136px;

        &.ab {
          top: 192px;
        }
      }

      &.scrollbar {
        .domain-item {
          padding: 8px 3px 8px 9px;
        }
      }

      .domain-item {
        min-height: 48px;
        padding: 18px 18px 18px 0;
        box-sizing: border-box;
        cursor: pointer;

        &:first-child {
          border-top: 1px dashed #CDCDCD;
        }
        &:not(:last-child) {
          border-bottom: 1px dashed #CDCDCD;
        }

      &.fold {
        .site__list--wrap {
          display: block;
        }
        .domain-text .icon--toggle-slide14 { transform: translateY(-50%) rotate(180deg); }
      }

      &.hide {
        display: none;
        opacity: 0;
      }

      .site__list--wrap {
        display: none;
      }

      .domain-text {
        pointer-events: inherit;
        position: relative;
        display: inline-block;
        width: 100%;
        height: 100%;
        padding-left: 3px;
        padding-right: 20px;
        box-sizing: border-box;
        color: #444;
        font-size: 12px;
        font-weight: 400;
        line-height: 100%;
        border-radius: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;

        &.on {
          color: $brandColor;
        }
        &.on.edit-mode {
          color: #289eef;
        }

        .icon {
          position: absolute;
          top: 50%;
          right: 5px;
          transform: translateY(-50%);
        }
      }
    }
  }
}

  .site__list--wrap {
    .site-item {
      border: 1px solid #e7e7e7;
      border-radius: 12.5px;
      color: #444444;
      margin-top: 10px;
      width: 100%;
      font-size: 13px;
      line-height: 21px;
      padding: 1px 8px 1px 8px;
      box-sizing: border-box;
      position: relative;

      .category__list--wrap {
        display: none;
      }

      &.fold {
        border-color: #bbbbbb;
        padding-top: 8px;
        padding-bottom: 10px;

        .category__list--wrap {
          display: block;
        }
        .site-text .icon--toggle-slide14 {
          top: 18px;
          transform: translateY(-50%) rotate(180deg);
        }
      }

      .site-text {
        @include textEllipsis;
        padding: 0 25px 0 5px;
        cursor: pointer;

        &.on {
          color: $brandColor;
        }

        &.on.edit-mode {
          color: #289eef;
        }
      }

      .icon {
        position: absolute;
        top: 50%;
        right: 7px;
        transform: translateY(-50%);
      }
    }
  }

  .category__list--wrap {
    .category-item {
      color: #444444;
      margin-top: 9px;
      width: 100%;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      line-height: 100%; /* 12px */
      box-sizing: border-box;
      cursor: pointer;
      position: relative;
      padding: 4px 8px 5px 7px;

      &:first-child {
        margin-top: 16px;
      }

      &:not(.active):hover {
        background-color: #ebebeb;
      }
      &.active {
        background-color: $brandColor;
        color: #fff;

        .icon {
          background-image: url(../../assets/img/dashboard/icon_shared_hover.svg);
        }
      }
      &.active.edit-mode {
        background-color: #289eef;
      }

      .icon {
        position: absolute;
        top: 50%;
        right: 7px;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
